// src/neuronest/CapacityEvaluator.js
import React, { useState } from 'react';

const CapacityEvaluator = () => {
    const [planned, setPlanned] = useState(20);
    const [actual, setActual] = useState(8);
    // Suggest halfway adjustment toward your real throughput:
    const suggested = Math.floor(actual + (planned - actual) * 0.5);

    return (
        <div className="p-4 bg-yellow-50 rounded shadow-sm my-2 mx-4">
            <h2 className="font-semibold text-yellow-700">Daily Capacity ⚖️</h2>

            {/* Inputs to drive planned & actual */}
            <div className="flex flex-col sm:flex-row sm:space-x-4 my-2">
                <label className="flex flex-col text-sm">
                    Planned:
                    <input
                        type="number"
                        min="0"
                        value={planned}
                        onChange={e => setPlanned(Number(e.target.value))}
                        className="mt-1 px-2 py-1 border rounded text-black w-24"
                    />
                </label>
                <label className="flex flex-col text-sm">
                    Completed:
                    <input
                        type="number"
                        min="0"
                        value={actual}
                        onChange={e => setActual(Number(e.target.value))}
                        className="mt-1 px-2 py-1 border rounded text-black w-24"
                    />
                </label>
            </div>

            <p className="mt-2">
                You planned <strong>{planned}</strong> tasks but completed{' '}
                <strong>{actual}</strong>. We suggest{' '}
                <strong>{suggested}</strong> tasks today for steady progress.
            </p>
        </div>
    );
};

export default CapacityEvaluator;
